module.exports = __webpack_public_path__ + "static/media/criativos_feminino_beleza.14d6eb4c.jpg";